import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, withCtx as _withCtx, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = ["title"];
const _hoisted_2 = {
  key: 1,
  class: "placeholder"
};
export default {
  name: 'input-select',
  props: {
    modelValue: String,
    disabled: {
      type: Boolean,
      default: false
    }
  },
  emits: ['update:modelValue', 'select'],

  setup(__props, {
    emit: emits
  }) {
    const props = __props;

    function clearHandle() {
      emits('update:modelValue', '');
      emits('clear');
    }

    function selectHandle() {
      if (props.disabled === false) {
        emits('select');
      }
    }

    return (_ctx, _cache) => {
      const _component_Close = _resolveComponent("Close");

      const _component_el_icon = _resolveComponent("el-icon");

      const _component_ArrowDown = _resolveComponent("ArrowDown");

      return _openBlock(), _createElementBlock("div", {
        class: _normalizeClass(["van-input-select", {
          disabled: props.disabled
        }]),
        onClick: selectHandle
      }, [props.modelValue ? (_openBlock(), _createElementBlock("span", {
        key: 0,
        class: "input ellipsis",
        title: props.modelValue
      }, _toDisplayString(props.modelValue), 9, _hoisted_1)) : (_openBlock(), _createElementBlock("span", _hoisted_2, "请选择")), props.modelValue ? (_openBlock(), _createBlock(_component_el_icon, {
        key: 2,
        onClick: _withModifiers(clearHandle, ["stop"])
      }, {
        default: _withCtx(() => [_createVNode(_component_Close)]),
        _: 1
      }, 8, ["onClick"])) : (_openBlock(), _createBlock(_component_el_icon, {
        key: 3
      }, {
        default: _withCtx(() => [_createVNode(_component_ArrowDown)]),
        _: 1
      }))], 2);
    };
  }

};